<template>
    <div>
      <Header :pageTitle="'会议图片'" />
      <div class="images">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
        <img src="@/assets/img/qietu/1.jpg" alt="">
      </div>
    </div>
</template>

<script>
import Header from '@/views/mobileView/detail/components/Header.vue'
export default {
     name:'jumpmeetingImages',
    components: {
      Header
    },
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {

    },
};
</script>

<style scoped lang="scss">
.images{
  width: 100%;
  height: 500px;
  padding-left: 25px;
  margin-top: 71px;
  display: flex;
  justify-content:flex-start;
  align-content: flex-start;
  flex-wrap:wrap;
}
img{
  margin-top: 10px;
  width: 150px;
  height: 150px;
  margin-right: 10px;
}
</style>
